<!-- eslint-disable vue/no-v-html -->
<template>
  <v-container fluid>
   <v-row>
      <v-col class="main_title">
        <v-flex tag="h2" class="primary-text"> Configuration </v-flex>
        <v-divider class="mt-4" />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3" class="pb-0">
        <v-select v-model="selectedProduct" filled append-icon="expand_more" label="Select Product" :items="products" @change="getDynmicalUlr()"
          :item-text="(item) => item.value" :item-value="(item) => item.id" attach />
      </v-col>
    </v-row>
    <v-row class="d-flex mt-2 pt-0">
      <h2 class="ma-4">
        Dynamic URL
      </h2>

    </v-row>
    <v-form v-model="valid">
      <v-row v-for="(url, i) in urls.filter(el => !el.isremoved)" :key="i" no-gutters>
        <v-col class="d-flex steps-col" sm="4">
          <v-text-field v-model="url.endPoint" label="Enter Url" filled :rules="businessRules" />
        </v-col>
        <v-col class="mt-3 pl-2">
          <v-btn icon @click="addUrl(i)">
            <v-icon color="#7F7F7F" size="18" class="font-weight-bold">mdi-plus-circle-outline</v-icon>
          </v-btn>
          <v-btn v-if="urls.filter(el => !el.isremoved).length > 1" icon @click="removeUrl(url, i)">
            <v-icon color="#7F7F7F" size="18" class="font-weight-bold">mdi-minus-circle-outline</v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-3 pl-2" cols="6">
          <span>{{ `${baseURL}${url.endPoint}` }}</span>
          <v-icon small class="pl-2" @click="copy(`${baseURL}${url.endPoint}`)">
            mdi-content-copy
          </v-icon>

        </v-col>
      </v-row>
      <v-row>
        <v-col sm="4" class="text-end mt-8 p-4">
          <v-btn depressed class="secondary_btn small  mr-4" style="display:none">Cancel</v-btn>
          <v-btn depressed :disabled="!valid" class="primary_btn small mr-0" @click="saveEndpoints">
            Save</v-btn>
        </v-col>
        <v-col sm="4" class="text-end mt-8 p-4">
          <v-btn depressed :disabled="!valid" class="secondary_btn small mr-0" @click="copyUrls">
            Copy Urls</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="mt-4" />
    <v-row>
      <v-col md="3" class="pb-0">
        <v-select v-model="selectedEndpoint" filled append-icon="expand_more" label="Page" :items="urls.filter(e=>e.endPoint!=''&& e.isremoved!=true&&e.id!=undefined)"
          :item-text="(item) => item.endPoint" :item-value="(item) => item.id" attach @change="htmlcontent" />

      </v-col>
      <v-col md="3" class="pb-0"><v-text-field v-model="titleText" label="Title" filled /></v-col>
      <v-col md="2">
        <v-btn
        depressed class="primary_btn small mr-0 mt-3"
        @click="uploadImagePopup = true"
        >
        Upload Image
        </v-btn>
      </v-col>
      <v-col v-if="urlvalue" md="4" >
        <div class="mt-5">
        <span>{{ urlvalue }}</span>
          <v-icon small class="pl-2" @click="copy(`${urlvalue}`)">
            mdi-content-copy
          </v-icon>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" class="pb-0">
        <v-textarea v-model="metaDes" name="input-7-1" variant="filled" label="Meta" auto-grow
          model-value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through." />
      </v-col>
      <v-col v-if="isLoaded" md="6" class="pb-0">
        <html-codemirror v-model="loginHtmlContent" :value.sync="loginHtmlContent" :options="codeMirrorOptions"
          class="ted-login-code-mirror" />
      </v-col>
    </v-row>
    <v-row class="p-8">
      <v-col v-if="isLoaded" md="5" class="pb-0">
        <v-card>
          <html-codemirror v-model="htmlData" :value.sync="htmlData" class="ted-code-mirror"
            :options="codeMirrorOptions" />
        </v-card>
      </v-col>
      <v-col md="7" class="p-2">
        <div class="onboardingRegister">
          <div class="d-flex ">
            <div cols="6">
              <div v-html="htmlData" />
              <!-- <div class="rightContent px-2">
                                    <div class="d-flex">
                                        <div cols="7">
                                            <div class="caption"> Limitless data exploration </div>
                                            <h2 class="text-uppercase my-0 text-bold">
                                                Value Stream
                                            </h2>
                                            <p class="text-uppercase mb-0">
                                                Intelligent Platform
                                            </p>
                                            <ui>
                                                <li>
                                                    Data collection using over 50+ built in connectors

                                                </li>
                                                <li>
                                                    Data collection using over 50+ built in connectors

                                                </li>
                                                <li>
                                                    Value Stream level monitoring capability

                                                </li>
                                                <li>
                                                    Recommendation Engine to better organize VSMs
                                                </li>
                                                <li>
                                                    Custom Metric Build and Custom Metric Assignment

                                                </li>
                                                <li>
                                                    Data Correlation and Aggregation capability

                                                </li>
                                            </ui>
                                              </div>
                                        <div cols="5">
                                            <img src="images/signLatest.svg" alt="Graphic">
                                        </div>
                                    </div>
                                    <div class="d-flex justify-end">
                                        <div class="text-right copyright mt-6">
                                            All Rights Reserved © Qentelli
                                        </div>
                                    </div>
                                </div> -->

            </div>
            <div cols="5">
              <div class="d-flex">
                <div cols="12">
                  <div class="registerDetails column">
                    <div class="col self-center">
                      <div class="registerForm">
                        <div v-html="loginHtmlContent" />
                        <div class="d-flex flex-column">
                          <!-- <div cols="12">
                            <v-text-field hide-details height="10" label="Company Name" type="text" class="m-0 p-0"
                              filled />
                          </div> -->
                          <div cols="12">
                            <v-text-field hide-details filled label="Email Address" type="text" class="mt-2 p-0 mb-2" />
                          </div>
                          <div class="d-flex content p-0 m-0">
                            <v-checkbox dense class="p-0" />
                            <span>I have read and agree to the
                              <a href="javascript:void(0)" class="link-color text-decoration-none">Terms of
                                Service.</a></span>

                          </div>
                          <div cols="12">
                            <v-btn class="primary_btn small" depressed>Register</v-btn>
                          </div>
                        </div>
                        <div class="d-flex">

                          <div cols="12" class="content">
                            <p>
                              Already have an account?
                              <router-link to="/login" class="link-color text-decoration-none">
                                Sign In
                              </router-link>
                            </p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="12" class="text-end mt-8 p-4">
        <v-btn depressed class="secondary_btn small  mr-4" style="display:none">Cancel</v-btn>
        <v-btn depressed :disabled="!valid" class="primary_btn small mr-0" @click="SaveConfiguration">
          Save</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="uploadImagePopup" persistent max-width="400px">
      <v-card class="custom-dialog">
        <v-container>
          <v-card-title class="d-flex">
            <span class="text-h5 text-uppercase font-weight-bold">
              Upload Image
            </span>
            <v-spacer/>
            <v-btn icon color="black" @click="uploadImagePopup = false,$refs.form.reset()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-form ref="form" v-model="valid" class="form-right-view-table">
            <v-card-text style="padding: 0px; min-height: auto;">
              <v-divider class="mb-10" />
              <v-row class="no-gutters">
                <v-col cols="12">
                  <v-file-input v-model="files" accept="image/*" label="Upload Image" filled/>
                </v-col>
              </v-row>
            </v-card-text>
            <!-- <v-container>
              <v-divider />
            </v-container> -->
            <v-card-actions>
              <v-spacer />
              <v-btn
                class="secondary-btn"
                text
                @click="uploadImagePopup = false,$refs.form.reset()"
              >
                Cancel
              </v-btn>
              <v-btn
                :disabled="!valid || !files"
                text
                class="primary-btn"
                @click="SaveImages(files),$refs.form.reset()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { storeActions } from '@/store/actions.constants';
import config, { TEDURL ,MOBEURL,PACEURL} from '../../../config'
import HtmlCodemirror from './HtmlCodemirror.vue';
export default {
  components: {
    HtmlCodemirror
  },
  data() {
    return {
      valid: false,
      htmlData:
        `<div class="rightContent">
   <div class="value-stream">
      <div cols="left-pan">
		<div class="header">
         <small> Limitless data exploration </small>
         <strong>
            Value Stream
         </strong>
		  <span> Intelligent Platform</span>

	 </div>
         <div class="list">
            <span><img width="21" src="/images/data.png">
            Data collection using over 50+ built in connectors</span>
            <span><img width="21" src="/images/data-science.png">
            Value Stream level monitoring capability </span>
            <span><img width="21" src="/images/growth.png">
            Recommendation Engine to better organize VSMs</span>
            <span><img width="21" src="/images/data-analytics.png">
            Custom Metric Build and Custom Metric Assignment</span>
            <span><img width="21" src="/images/metric.png">
            Data Correlation and Aggregation capability</span>
         </div>
      </div>
      <div class="right-pan">
         <img src="/images/signLatest.svg" alt="Graphic" class="graphic">
      </div>
   </div>
   <div class="footer">
      <div class="text-right copyright mt-6">
         All Rights Reserved © Qentelli
      </div>
   </div>
</div>
<style>
   .rightContent {
   margin-top: 60px;
   position: relative;
	 padding: 0 10px;
   }
   .value-stream {
   display: flex;
   }
   .value-stream .list span {
   display: block;
   position: relative;
   padding-left: 30px;
   line-height: normal;
   margin-top: 10px;
	 color: #121212;
	 font-size: 0.9rem;
	 line-height: 24px;
   }
   .value-stream .list span img {
   position: absolute;
   left: 0;
   }
  .value-stream .right-pan img {
	height: 100px;
  }
  .value-stream .header {
	color: #002967;
	text-transform: uppercase;
	font-size: 1.5rem;
  }
  .value-stream .header small {
	color: #02529A;
	font-size: 0.9rem;
	text-transform: capitalize;
  }
  .value-stream .header strong {
	display: block;
	font-weight: 700;
  }
  .value-stream .header span {
	font-size: 1rem;
  }
   .copyright {
   font-size: 0.5rem;
   color: #666666;
   position: relative;
   }
   .footer{
  margin-top: 2.8rem
  }
</style>`,
      urls: [{ endPoint: '', isremoved: false }],
      isLoaded: false,
      businessRules: [
        (v) => !!v || 'Url is Required',
        (v) => !(v.length > 0 && /^[^\\/]/.test(v)) || 'Initial character should a Backward slash',
        (v) => !!(v && v.toString().split(' ').length <= 1) || 'No spaces are allowed in between 2 words',
        (v) => !!(v.trim().length > 2 && v.trim().length < 31) || "String length should be between 3 to 30",
        (v) => /^[A-Za-z0-9_./# &+-]{3,30}$/.test(v) || "Only _./#&+- special characters and numbers are allowed",
      ],
      baseURL:'',
      baseTedURL: config.TEDURL,
      baseMObeURL:config.MOBEURL,
      basePaceURL:config.PACEURL,
      selectedEndpoint: null,
      uploadImagePopup:false,
      urlvalue:'',
      files:null,
      selectedProduct: 1,
      products:[{id:1,value:'TED'},{id:2,value:'MOBE'},{id:3,value:'PACE'}],
      loginHtmlContent: `
      <strong class="text-h3 mb-sm block head">Let's sign you
      up</strong>
      <p class='content mb-lg'>
      Please fill in the below details to register for TED.
      </p>`,
      titleText: 'Register | TED - The Engineering Dashboard',
      metaDes: 'Data collection using over 50+ built-in connectors. Value Stream level monitoring capability. Recommendation Engine to better organize VSMs. Custom Metric Build ',
    }
  },
  computed: {
    codeMirrorOptions() {
      return {
        tabSize: 4,
        mode: "htmlmixed",
        lineNumbers: true,
        indentWithTabs: true,
        smartIndent: true,
        autofocus: true,
        extraKeys: { 'Ctrl-Space': 'autocomplete' },
        hintOptions: {
          completeSingle: false,
          tables: this.tableOptions,
        },
        // theme: 'cobalt',
        line: true,
        showHint: true,
      };
    },
  },
  async mounted() {

    // await this.getEndpoint().then(res => {
    //   this.urls = res.data.content.length === 0 ? [{ endPoint: '' }] : res.data.content.map(el => {
    //     el.isremoved = false
    //     return el
    //   })
    //   this.selectedEndpoint = this.urls[0].id
    // })
    // this.htmlcontent()
    this.getDynmicalUlr()
  },
  methods: {
    async getDynmicalUlr()
    {
      if(this.selectedProduct==1){
        this.baseURL=this.baseTedURL
      }
      else if(this.selectedProduct==2){
        this.baseURL=this.baseMObeURL
      }
      else if(this.selectedProduct==3){
        this.baseURL=this.basePaceURL
      }
      await this.getEndpoint(this.selectedProduct).then(res => {
        if(res?.status==200){
      this.urls = res.data.content.length === 0 ? [{ endPoint: '' }] : res.data.content.map(el => {
        el.isremoved = false
        return el
      })
      this.selectedEndpoint = this.urls[0].id

    }else{
      this.urls=[{ endPoint: '', isremoved: false }];
      this.selectedEndpoint=null;
    }
    })
    this.htmlcontent()

    },

    async htmlcontent() {
      this.isLoaded = false
      await this.getHtmlContent({ id: this.selectedEndpoint }).then(res => {
        if (res.data.content) {
          this.htmlData = res.data.content?res.data.content.replace(/\/'\//g, "'") :this.htmlData
          this.metaDes=res.data.meta || this.metaDes
          this.titleText=res.data.title || this.titleText
          this.loginHtmlContent=res.data.loginHtml ?res.data.loginHtml.replace(/\/'\//g, "'") :`<strong class="text-h3 mb-sm block head">Let's sign you
      up</strong>
      <p class="content mb-lg">
      Please fill in the below details to register for TED.
      </p>`
        }
        this.isLoaded = true
      })

    },
    addUrl(i) {
      this.urls.splice(++i, 0, { endPoint: '', isremoved: false })
    },
    removeUrl(url, i) {
      if(url.endPoint!=''){
        this.urls[this.urls.findIndex(el => el.endPoint === url.endPoint)].isremoved = true
      }
      else{
        url.isremoved = true
      }
    },
    async saveEndpoints() {
      await this.saveEndpoint({ data: this.urls.filter(e=>(e.id==undefined ? e.isremoved!=true:true)),productId:this.selectedProduct }).then(res => {
        if (res.status !== 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'error',
          });

        }
        else {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'Urls Created Successfully',
            timeout: 3000,
            color: 'success',
          });
         this.getDynmicalUlr()

        }
      })
    },
    async SaveConfiguration() {
      await this.saveContent({ content: this.htmlData.replace(/'/g, "/\\'/"), id: this.selectedEndpoint, meta: this.metaDes, title: this.titleText, loginHtml: this.loginHtmlContent.replace(/'/g, "/\\'/") }).then(res => {
        if (res.status !== 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'error',
          });

        }
        else this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Urls Created Successfully',
          timeout: 3000,
          color: 'success',
        });

      })

    },
    async SaveImages(fileValue){
      await this.saveImage({file: fileValue}).then(res =>{
        if(res.status !== 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'error',
          });
        }
        else
        {
          this.urlvalue = res.data.Location
          this.files = null
          this.uploadImagePopup = false
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: 'Images Uploaded Successfully',
            timeout: 3000,
            color: 'success',
          });
        }
      })
    },
    copy(text) {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
        text: 'Copied to Clipboard',
        timeout: 3000,
        color: 'blue',
      });

    },
    copyUrls() {
      const el = document.createElement('textarea');
      this.urls.forEach(oo => {
        el.value += this.baseURL + oo.endPoint + '\n'
      });
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
        text: 'Copied to Clipboard',
        timeout: 3000,
        color: 'blue',
      });
    },
    ...mapActions({
      saveContent: 'Marketing/addHtmlContent',
      getHtmlContent: 'Marketing/GetHTMLContent',
      saveEndpoint: 'Marketing/createEndPoints',
      getEndpoint: 'Marketing/getDynamicUrls',
      saveImage: 'Marketing/uploadImage',
    })
  }
}
</script>

<style scoped>
.ted-code-mirror ::v-deep .CodeMirror {
  height: 600px !important;

  /* Set height, width, borders, and global font properties here */
}

.ted-login-code-mirror ::v-deep .CodeMirror {
  max-height: 120px !important;
}
</style>

<style lang="scss" scoped>
.onboardingRegister {

  background-image: url('../../assets/img/cloudDataBg.svg');
  background-position: right bottom;
  background-repeat: no-repeat;

  .rightContent {
    margin-top: 60px;

    position: relative;

    h2,
    p {
      color: #051e44;
      font-size: 18px;
    }

    ui,
    li {
      font-size: 12px;
    }

    p {
      position: relative;
      top: -5px;
    }

    li :before {
      content: ('/images/metric.png');


    }

    .graphic {
      width: 150px
    }

    .caption {
      color: #051e44;
      font-size: 8px;
    }

    img {
      width: 150px;
    }

    .v-list {
      img {
        width: 14px;
      }

      .v-list-item__content {
        font-size: 10px;
      }
    }

    .copyright {
      font-size: 8px;
      color: #666666;
      position: relative;
    }
  }

  .registerDetails {
    width: fit-content;
    height: calc(80vh - 26.5px);
    background-color: #fff;
    box-shadow: 0px 1px 5px rgba(189, 189, 189, 0.5);
    margin-top: 0px;
    // pointer-events: none;

    .registerForm {
      margin-top: 40px;
      padding: 0 5px;

      .head {
        font-size: 14px;
      }

      .content {
        font-size: 10px;
      }
    }

    .content {
      font-size: 12px;

      .v-input--selection-controls {
        margin-top: 0px;
      }
    }
  }
}
</style>
